import api from './api';

const AddressService = {
    getAddresses: () => {
        return api.get('users/addresses/');
    },

    createAddress: (data) => {
        return api.post('users/addresses/', data);
    },

    updateAddress: (id, data) => {
        return api.patch(`users/addresses/${id}/`, data);
    },

    deleteAddress: (id) => {
        return api.delete(`users/addresses/${id}/`);
    },

    setDefaultAddress: (id) => {
        return api.post(`users/addresses/${id}/set_default/`);
    }
};

export default AddressService;
